/**
 * D001: Typed wrappers for SECURITY DEFINER RPCs replacing cross-user `public.users` SELECT.
 */
import type { SupabaseClient } from '@supabase/supabase-js';

export async function rpcDiscoverCandidatesForViewer(
  supabase: SupabaseClient,
  pLimit = 50
) {
  return supabase.rpc('discover_candidates_for_viewer', { p_limit: pLimit });
}

export async function rpcPeerUsersForViewer(
  supabase: SupabaseClient,
  peerIds: string[],
  opts?: { includePrefs?: boolean; inviteCode?: string | null }
) {
  const unique = [...new Set(peerIds.filter(Boolean))];
  if (unique.length === 0) {
    return { data: [] as Record<string, unknown>[], error: null };
  }
  return supabase.rpc('peer_users_for_viewer', {
    peer_ids: unique,
    include_prefs: opts?.includePrefs ?? false,
    p_invite_code: opts?.inviteCode ?? null,
  });
}

export async function rpcIncomingConnectionRequestsForViewer(supabase: SupabaseClient) {
  return supabase.rpc('incoming_connection_requests_for_viewer');
}

export async function rpcChatUsersForViewer(
  supabase: SupabaseClient,
  pChatId: string,
  pUserIds: string[]
) {
  const unique = [...new Set(pUserIds.filter(Boolean))];
  if (unique.length === 0) {
    return { data: [] as Record<string, unknown>[], error: null };
  }
  return supabase.rpc('chat_users_for_viewer', {
    p_chat_id: pChatId,
    p_user_ids: unique,
  });
}

/** Active Founding 100 leaderboard: user rows authorized via founding_100_applications (not graph-scoped). */
export async function rpcBarIlanFoundingUsersForViewer(
  supabase: SupabaseClient,
  userIds: string[]
) {
  const unique = [...new Set(userIds.filter(Boolean))];
  if (unique.length === 0) {
    return { data: [] as Record<string, unknown>[], error: null };
  }
  return supabase.rpc('bar_ilan_founding_users_for_viewer', { p_user_ids: unique });
}
